/**
 * Converts an angle in degrees to the equivalent angle in radians.
 *
 * @param {number} deg - The angle in degrees.
 * @returns {number} The angle in radians.
 */
export default function convertDegreesToRadians(deg) {
  return deg * (Math.PI / 180);
}